/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React, { useState } from "react";
import "rodal/lib/rodal.css";

import { Button, SimpleModal } from "UpduoLibrary";
import { skaleSoftRed, skaleWhite } from "config/UpduoColors";

interface EndChatModalProps {
  onCancelChatConfirm: Function;
  isVisible: boolean;
  onDismiss: Function;
}

export default function EndChatModal({
  onCancelChatConfirm,
  isVisible,
  onDismiss,
}: EndChatModalProps) {
  const [buttonsDisabled, setButtonsDisabled] = useState(false);

  const _handleCancelChat = () => {
    onCancelChatConfirm();
    setButtonsDisabled(true);
  };

  return (
    <SimpleModal
      isVisible={isVisible}
      onClose={() => onDismiss()}
      description={"You haven't reached the end yet!\nLeave anyway?"}
      descriptionStyle={{ fontFamily: "ObjectSans-Regular" }}
      buttons={[
        <Button
          key={"leave"}
          marginTop={30}
          disabled={buttonsDisabled}
          onPress={() => _handleCancelChat()}
          text={"Leave"}
          color={skaleWhite}
          textColor={skaleSoftRed}
          borderWidth={1}
          borderColor={skaleSoftRed}
          disabledTextColor={skaleSoftRed}
          width={330}
        />,
        <Button
          key={"continue"}
          marginTop={20}
          disabled={buttonsDisabled}
          onPress={() => {
            setButtonsDisabled(true);
            onDismiss();
            setButtonsDisabled(false);
          }}
          text={"Continue Session"}
          width={330}
        />,
      ]}
    />
  );
}
